import { axios, updateOrder } from '@stars-ecom/shared-organisms-ui'
import { navigate } from 'gatsby'
import debounce from 'lodash/debounce'
import get from 'lodash/get'

const addItemToOrder = async (productVariantId, quantity, type = 'STANDARD', parentOrderLine) => {
  try {
    const customFields = { type }
    if (parentOrderLine) {
      customFields.parentOrderLine = parentOrderLine
    }
    const result = await axios.post(
      `order/${process.env.GATSBY_API_VERSION}/${process.env.GATSBY_API_CHANNEL_ID}/addItemToOrder`,
      { productVariantId, quantity, customFields }
    )
    const data = get(result, 'data', {})
    if (data.__typename === 'Order') {
      updateOrder(result.data)
    } else {
      // OrderModificationError | OrderLimitError | NegativeQuantityError
      console.error(result)
    }
    return data
  } catch (e) {
    await getActiveOrder()
    console.error(e)
    return {}
  }
}

let checkCaastExist = setInterval(() => {
  if (typeof window !== 'undefined' && window) {
    if (typeof window.caast !== 'undefined') {
      if (typeof window.caastIsListeningCart === 'undefined') {
        caast
          .on('onBasketAdd', (data) => {
            const PRODUCT_DETAIL = data.product_detailed;
            let productVariantId = PRODUCT_DETAIL.attributes.additionalCartData.productVariantId;
            if (!productVariantId && PRODUCT_DETAIL.attributes.childProducts.length > 0) {
              const selectedProduct = PRODUCT_DETAIL.attributes.childProducts.find(p => p.attributes.ref === data.product_ref);
              if (!!selectedProduct)
                productVariantId = selectedProduct.attributes.additionalCartData.productVariantId;
            }
            if (typeof addItemToOrder !== 'undefined' && !!productVariantId) {
              addItemToOrder(productVariantId, 1)
            }
          })
          .then(() => {
            window.caastIsListeningCart = true;
          })
          .catch((error) => console.error('checkCaastExist error', error));
      }
    }
  }
}, 100);

const getDetailPromo = async (couponCode) => {
  try {
    const result = await axios.get(
      `order/${process.env.GATSBY_API_VERSION}/${process.env.GATSBY_API_CHANNEL_ID}/getDetailPromo`,
      { params: { couponCode } }
    );
    if (result?.data?.data?.length > 0)
      return get(result, 'data.data', {});
    else
      return null;
  } catch (e) {
    console.error(e)
    return {};
  }
}

const removeOrderLine = async (orderLineId) => {
  try {
    const result = await axios.post(
      `order/${process.env.GATSBY_API_VERSION}/${process.env.GATSBY_API_CHANNEL_ID}/adjustOrderLine`,
      { orderLineId, quantity: 0 }
    )
    if (result.data.__typename === 'Order') {
      updateOrder(result.data)
      return get(result, 'data', {})
    }
  } catch (e) {
    await getActiveOrder()
    console.error(e)
    return {}
  }
}

const validateCartInventory = async () => {
  try {
    const result = await axios.post(
      `order/${process.env.GATSBY_API_VERSION}/${process.env.GATSBY_API_CHANNEL_ID}/validateCartInventory`
    )
    if (result.data.__typename === 'Order') {
      updateOrder(result.data)
      return get(result, 'data', {})
    } else if (result.data.__typename === 'CartInventoryError') {
      updateOrder(result.data.order)
      return get(result, 'data', {})
    }
  } catch (e) {
    await getActiveOrder()
    console.error(e)
    return {}
  }
}

const adjustOrderLine = async (orderLineId, quantity) => {
  try {
    const result = await axios.post(
      `order/${process.env.GATSBY_API_VERSION}/${process.env.GATSBY_API_CHANNEL_ID}/adjustOrderLine`,
      { orderLineId, quantity }
    )
    if (result.data.__typename === 'Order') {
      updateOrder(result.data)
      return get(result, 'data', {})
    } else {
      await getActiveOrder()
      return get(result, 'data', {})
    }
  } catch (e) {
    await getActiveOrder()
    console.error(e)
  }
}

const getActiveOrder = async () => {
  try {
    const result = await axios.get(
      `order/${process.env.GATSBY_API_VERSION}/${process.env.GATSBY_API_CHANNEL_ID}/getActiveOrder`
    )
    if (result.data.__typename === 'Order') {
      updateOrder(result.data)
      return get(result, 'data', {})
    } else {
      updateOrder({})
    }
  } catch (e) {
    console.error(e)
    return {}
  }
}

const applyCouponCode = async (couponCode) => {
  try {
    const result = await axios.post(
      `order/${process.env.GATSBY_API_VERSION}/${process.env.GATSBY_API_CHANNEL_ID}/applyCouponCode`,
      { couponCode: couponCode?.toUpperCase() }
    )
    if (result.data.__typename === 'Order') {
      updateOrder(result.data)
      return get(result, 'data', {})
    } else {
      return {
        __typename: result.data.__typename,
        errorCode: result.data.error || result.data.errorCode
      }
    }
  } catch (e) {
    console.error(e)
    return {}
  }
}

const removeCouponCode = async (couponCode) => {
  try {
    const result = await axios.post(
      `order/${process.env.GATSBY_API_VERSION}/${process.env.GATSBY_API_CHANNEL_ID}/removeCouponCode`,
      { couponCode }
    )
    if (result.data.__typename === 'Order') {
      updateOrder(result.data)
      return get(result, 'data', {})
    }
  } catch (e) {
    console.error(e)
    return {}
  }
}

const addPaymentToOrder = async (method, metadata, saveCard = false) => {
  try {
    const result = await axios.post(
      `order/${process.env.GATSBY_API_VERSION}/${process.env.GATSBY_API_CHANNEL_ID}/addPaymentToOrder`,
      { input: { method, metadata }, saveCard }
    )
    if (result.data.__typename === 'Order') {
      debounce(updateOrder, 200)({})
      return get(result, 'data', {})
    }

    //Redirect to failure payment page
    const paymentErrorCodes = ['PAYMENT_FAILED_ERROR', 'ORDER_PAYMENT_STATE_ERROR']
    if (paymentErrorCodes.includes(result.data.errorCode)) {
      navigate('/checkout/payment/failure')
      return {}
    }

    if (result.data.errorCode === 'PAYMENT_DECLINED_ERROR') {
      return get(result, 'data', {})
    }
  } catch (e) {
    console.error(e)
    return {}
  }
}

const validate3ds = async (transactionId, state) => {
  try {
    const result = await axios.post(
      `order/${process.env.GATSBY_API_VERSION}/${process.env.GATSBY_API_CHANNEL_ID}/payments/${transactionId}/3ds/${state}`
    )

    if (result && result?.data?.success && state === 'Accept') {
      debounce(updateOrder, 200)({})
      //updateOrder(result.data)
    }

    return get(result, 'data', {})
  } catch (e) {
    console.error(e)
    return {}
  }
}

const eligiblePaymentMethods = async () => {
  try {
    const result = await axios.get(
      `order/${process.env.GATSBY_API_VERSION}/${process.env.GATSBY_API_CHANNEL_ID}/eligiblePaymentMethods`
    )
    if (result.data.errorCode) {
      console.error(result)
      return []
    } else {
      return get(result, 'data', [])
    }
  } catch (e) {
    console.error(e)
    return []
  }
}

const eligibleShippingMethods = async () => {
  try {
    const result = await axios.get(
      `order/${process.env.GATSBY_API_VERSION}/${process.env.GATSBY_API_CHANNEL_ID}/eligibleShippingMethods`
    )
    if (result.data.errorCode) {
      console.error(result)
      return []
    } else {
      return get(result, 'data', [])
    }
  } catch (e) {
    console.error(e)
    return []
  }
}

const setShipping = async (params) => {
  try {
    const result = await axios.post(
      `order/${process.env.GATSBY_API_VERSION}/${process.env.GATSBY_API_CHANNEL_ID}/setShipping`,
      params
    )
    if (result.data.errorCode) {
      console.error(result)
      return get(result, 'data', [])
    }
    if (result.data.__typename === 'Order') {
      updateOrder(result.data)
      return get(result, 'data', {})
    }
  } catch (e) {
    console.error(e)
    return {}
  }
}
const generatePledgToken = async (paymentMethod) => {
  try {
    const result = await axios.get(
      `order/${process.env.GATSBY_API_VERSION}/${process.env.GATSBY_API_CHANNEL_ID}/${paymentMethod}/generatePledgToken`
    )
    if (result.data.errorCode) {
      console.error(result)
      return {}
    } else {
      return get(result, 'data')
    }
  } catch (e) {
    console.error(e)
    return {}
  }
}

export {
  getDetailPromo,
  addItemToOrder,
  addPaymentToOrder,
  adjustOrderLine,
  getActiveOrder,
  removeOrderLine,
  applyCouponCode,
  removeCouponCode,
  eligiblePaymentMethods,
  eligibleShippingMethods,
  setShipping,
  validate3ds,
  validateCartInventory,
  generatePledgToken
}
